import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle", "label", "icon"]
  static values = { limit: { type: Number, default: 1000 } }

  connect() {
    this.fullText = this.contentTarget.textContent
    this.expanded = false

    if (this.fullText.length > this.limitValue) {
      this.collapse()
    }
  }

  toggle() {
    if (this.expanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  collapse() {
    const truncated = this.fullText.substring(0, this.limitValue).trimEnd()
    this.contentTarget.textContent = truncated + "..."
    this.expanded = false

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.readMoreText
    }
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }

  expand() {
    this.contentTarget.textContent = this.fullText
    this.expanded = true

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.readLessText
    }
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = "rotate(180deg)"
    }
  }

  get readMoreText() {
    return this.element.dataset.readMoreText || "Read more"
  }

  get readLessText() {
    return this.element.dataset.readLessText || "Read less"
  }
}
